<script lang="ts" setup>
import { ref } from 'vue'
import { type AccordionRootProps } from 'reka-ui'

import { Carousel, CarouselContent, CarouselFooter, CarouselItem, CarouselPaginationDots, Separator } from '@toni/brand-ui'
import { ProductCardWithPurchaseOptions } from '@toni/commerce-api-types'

import { useClient } from '../../utils/is-client'
import ProductCardComparisonItem from './ProductCardComparisonItem.vue'
import AlternativePurchaseOptionsAccordion from './AlternativePurchaseOptionsAccordion.vue'
import TechnicalDataAccordion from './TechnicalDataAccordion.vue'
import ReviewAccordion from './ReviewAccordion.vue'

const props = defineProps<{
  productCards: ProductCardWithPurchaseOptions[]
}>()

const { isClient } = useClient()

const groupOfTwos: ProductCardWithPurchaseOptions[][] = []

for (let i = 0; i < props.productCards.length; i += 2) {
  groupOfTwos.push(props.productCards.slice(i, i + 2))
}

const reviewAccordionOpenId = ref<AccordionRootProps['modelValue']>('')
const technicalDataAccordionOpenId = ref<AccordionRootProps['modelValue']>('')
const alternativePurchaseOptionsAccordionOpenId = ref<AccordionRootProps['modelValue']>('')
</script>

<template>
  <Carousel
    variant="simple"
    class="w-full">
    <CarouselContent>
      <CarouselItem v-for="group in groupOfTwos"
                    :key="group[0]!.bauerProductCard.bauerProductCardId"
                    class="basis-full">
        <div class="flex gap-4 mb-4">
          <ProductCardComparisonItem v-for="product in group"
                                     :key="product.bauerProductCard.bauerProductCardId"
                                     class="basis-1/2"
                                     :product-card="product.bauerProductCard"
                                     :purchase-options="product.purchaseOptions" />
        </div>
        <ReviewAccordion v-if="isClient"
                         :product-cards="group"
                         :accordion-open-id="reviewAccordionOpenId"
                         @update-accordion-open-id="(value: AccordionRootProps['modelValue']) => reviewAccordionOpenId = value" />
        <TechnicalDataAccordion v-if="isClient"
                                :product-cards="group"
                                :accordion-open-id="technicalDataAccordionOpenId"
                                @update-accordion-open-id="(value: AccordionRootProps['modelValue']) => technicalDataAccordionOpenId = value" />
        <AlternativePurchaseOptionsAccordion v-if="isClient"
                                             :product-cards="group"
                                             variant="mobile"
                                             :accordion-open-id="alternativePurchaseOptionsAccordionOpenId"
                                             @update-accordion-open-id="(value: AccordionRootProps['modelValue']) => alternativePurchaseOptionsAccordionOpenId = value" />
      </CarouselItem>
    </CarouselContent>
    <Separator class="mt-4" />
    <CarouselFooter class="!grid-cols-1">
      <CarouselPaginationDots />
    </CarouselFooter>
  </Carousel>
</template>
